import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="opening-times"
export default class extends Controller {

  static targets = ["button"]

  toggle(){
    this.element.classList.toggle('closed');
    this.buttonTarget.innerText = this.element.classList.contains('closed') ? 'See all opening times and contact details' : 'Hide all opening times and contact details';
  }
}
